// PATH: src/config/adminEnv.js
// VERSION: 2.1 — + API_BASE_URL (dev/prod), texto plano o bcrypt

const fromB64 = (s) => {
  try { return typeof atob === 'function' ? atob(s) : Buffer.from(s, 'base64').toString('utf8'); }
  catch { return ''; }
};
const s = (v) => (v ?? '').toString().trim();

const plain    = s(process.env.REACT_APP_ADMIN_PASSWORD);
const hashText = s(process.env.REACT_APP_ADMIN_BCRYPT_HASH);
const hashB64  = s(process.env.REACT_APP_ADMIN_BCRYPT_HASH_B64);
const decodedB64 = hashB64 ? s(fromB64(hashB64)) : '';

if (plain && (hashText || decodedB64)) {
  // eslint-disable-next-line no-console
  console.warn('[ADMIN_AUTH] REACT_APP_ADMIN_PASSWORD está definido. Se ignorarán REACT_APP_ADMIN_BCRYPT_HASH(_B64).');
}

const ENV = {
  // ★ NUEVO: usado por axiosConfig
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api',

  // Auth admin
  ADMIN_PASSWORD: plain || '',
  ADMIN_BCRYPT_HASH: plain ? '' : (hashText || decodedB64 || ''),
  ADMIN_BYPASS: String(process.env.REACT_APP_ADMIN_BYPASS || 'false').toLowerCase() === 'true',
  ADMIN_SESSION_MINUTES: Number(process.env.REACT_APP_ADMIN_SESSION_MINUTES || '360'),
};

export default ENV;
